import classNames from 'classnames'
import Action from 'components/Action'
import Resource from 'components/Resource'
import style from 'components/ResourceGroup.module.scss'
import { AnimatePresence, motion } from 'framer-motion'
import {
  childVariants,
  contentVariants,
  parentVariants,
  rootVariants,
} from 'lib/constants'
import React, { useState } from 'react'
import { useInView } from 'react-intersection-observer'

const ResourceGroup = ({ resources, theme }) => {
  const [limit, setLimit] = useState(6)

  const { ref, inView, entry } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  })

  const handleClick = () => {
    setLimit(old => old + 6)
  }

  const className = classNames(style.root, style[`root___theme_${theme}`])

  const slicedResources = resources.slice(0, limit)

  return (
    <motion.div
      className={className}
      variants={rootVariants}
      initial="initial"
      animate={inView ? 'animate' : 'initial'}
      exit="exit"
      ref={ref}
    >
      <div className={style.content}>
        <ul className={style.resources}>
          {slicedResources.map(resource => {
            return (
              <li key={resource.id} className={style.resource}>
                <Resource
                  title={resource.title}
                  subTitle={resource.subTitle}
                  url={resource.url}
                  isVideo={resource.isVideo}
                  isRestricted={resource.restricted}
                  icon={resource.icon}
                  theme={theme}
                />
              </li>
            )
          })}
        </ul>

        {limit < resources.length && (
          <div
            className={style.action}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <Action label="Show More" onClick={handleClick} icon="Plus" />
          </div>
        )}
      </div>
    </motion.div>
  )
}

ResourceGroup.defaultProps = {
  resources: [],
  theme: 'light',
}

export default ResourceGroup
